/** Tutorial 4 bước cho người chơi mới (M2). */
import { useEffect, useState } from 'preact/hooks';
import type { GameController } from '../game-controller.js';
import { styleNutChinh, styleNutPhu, useCapNhat } from '../dung-chung.js';

const CAC_BUOC = [
  {
    tieuDe: 'Chào mừng đến sạp Phố chợ!',
    noiDung:
      'Khách sẽ tự vào mua hàng — bạn chỉ lo chiến lược: giá cả, nhập hàng, ' +
      'bố trí cửa hàng và nâng cấp. Cứ để cửa hàng chạy, tiền tự chảy vào.',
  },
  {
    tieuDe: 'Bước 1: Chọn chính sách giá',
    noiDung:
      'Mở bảng "Giá" bên trái và chọn một chính sách. "Rẻ" đông khách, ' +
      '"Đắt" lãi cao nhưng mất lòng khách.',
    tuDong: true,
  },
  {
    tieuDe: 'Bước 2: Đặt thêm nội thất',
    noiDung:
      'Mở bảng "Nội thất", chọn "Kệ gỗ" rồi bấm vào một ô trống trong cửa hàng. ' +
      'Nhớ chừa đường từ cửa đến quầy thu ngân!',
    tuDong: true,
  },
  {
    tieuDe: 'Bước 3: Nâng cấp khi đủ tiền',
    noiDung:
      'Đủ 150 xu thì mở bảng "Nâng cấp" để lên Tạp hóa: thêm mặt hàng, ' +
      'đông khách hơn, khu vực rộng hơn. Chúc buôn may bán đắt!',
  },
];

export function Tutorial(props: {
  controller: GameController;
  moBang: (ten: string) => void;
  soBoCucBanDau: number;
}) {
  const { controller } = props;
  const [buoc, setBuoc] = useState(0);
  useCapNhat(controller);

  // Tự qua bước khi người chơi đã làm: đổi chính sách / đặt thêm nội thất.
  useEffect(() => {
    if (buoc === 1 && controller.state.chinhSach !== 'canBang') setBuoc(2);
  }, [buoc, controller.state.chinhSach]);
  useEffect(() => {
    if (buoc === 2 && controller.state.boCuc.length > props.soBoCucBanDau) setBuoc(3);
  }, [buoc, controller.state.boCuc.length, props.soBoCucBanDau]);

  const buocHienTai = CAC_BUOC[buoc]!;

  const ketThuc = (): void => {
    controller.hoanThanhTutorial();
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '16px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'rgba(20, 14, 8, 0.95)',
        color: '#f5e9d0',
        border: '2px solid #c98a2e',
        borderRadius: '12px',
        padding: '16px 20px',
        maxWidth: '440px',
        width: '90%',
        zIndex: 40,
      }}
    >
      <h3 style={{ margin: '0 0 6px' }}>
        {buocHienTai.tieuDe}{' '}
        <span style={{ opacity: 0.6, fontSize: '13px' }}>
          ({buoc + 1}/{CAC_BUOC.length})
        </span>
      </h3>
      <p style={{ margin: '0 0 12px', fontSize: '14px' }}>{buocHienTai.noiDung}</p>
      <div style={{ display: 'flex', gap: '8px' }}>
        {buoc < CAC_BUOC.length - 1 ? (
          <>
            <button
              onClick={() => {
                if (buoc === 1) props.moBang('gia');
                if (buoc === 2) props.moBang('noithat');
                setBuoc(buoc + 1);
              }}
              style={styleNutChinh}
            >
              {buoc === 0 ? 'Bắt đầu' : 'Tiếp tục'}
            </button>
            <button onClick={() => setBuoc(buoc + 1)} style={styleNutPhu}>
              Bỏ qua bước này
            </button>
          </>
        ) : (
          <button onClick={ketThuc} style={styleNutChinh}>
            Bắt đầu buôn bán!
          </button>
        )}
        <button
          onClick={ketThuc}
          style={{
            marginLeft: 'auto',
            background: 'transparent',
            border: 'none',
            color: '#a08a60',
            cursor: 'pointer',
          }}
        >
          Đóng hướng dẫn
        </button>
      </div>
    </div>
  );
}
